import React, { useCallback } from 'react';
import { Route } from 'react-router-dom';

import JourneyItem from './JourneyItem';

import {
  StyledLoadingJourneys,
  StyledJourneysContainer,
  StyledZeroResults,
} from 'modules/assignment-cards/styled';

const t = {
  zero: 'Driver has no assigned jobs',
};

const renderJourneyItem = ({ journey, onClick, isSelected }) => (
  <JourneyItem journey={journey} onClick={onClick} isSelected={isSelected} />
);

const JourneysInfo = ({ onClick, isRoute = true, journeys = [], fetching = true }) => {
  const handleClick = useCallback(
    (id) => {
      if (onClick) {
        onClick(id);
        return;
      }
      window.open(`/jobs/${id}`, '_blank');
    },
    [onClick]
  );

  if (!fetching && !(journeys || []).length) {
    return <StyledZeroResults>{t.zero}</StyledZeroResults>;
  }

  const renderJourney = (journey) => {
    if (isRoute) {
      return (
        <Route
          key={journey.id}
          path={`/jobs/${journey.id}`}
          children={({ match }) =>
            renderJourneyItem({ journey, isSelected: !!match, onClick: handleClick })
          }
        />
      );
    }

    return renderJourneyItem({ journey, isSelected: false, onClick: handleClick });
  };

  return (
    <StyledJourneysContainer data-testid="journeys">
      {fetching && <StyledLoadingJourneys />}
      {journeys.map(renderJourney)}
    </StyledJourneysContainer>
  );
};

export default JourneysInfo;
